<section class="c-section c-section--first c-section--last c-section--open c-section--static">
	<div class="c-section__header" style="padding-bottom: 24px">
		<h1 class="c-section__title c-section__title--sm c-text c-text--center@md-and-up">
			<ng-container *ngIf="!vm.isChatBotEnabled">{{ 'Word_Cloud_Intermediate.Consultant' | translate }}</ng-container>
			<ng-container *ngIf="vm.isChatBotEnabled">{{ 'Word_Cloud_Intermediate.Supervised_By' | translate }}</ng-container>
			{{vm.getConsultantName()}}
		</h1>
	</div>
	<div class="c-section__content u-oh-visible">
		<div class="c-card">
			<div class="c-content c-content--xxl u-no-pt u-no-pb">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-100">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--center o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-ost-xxl u-osb-xxl">
								<div *ngIf="vm.consultant" class="c-text c-text--center">
									<div style="display: inline-block; position: relative;">
										<avatar *ngIf="vm.isChatBotEnabled" size="xl" [default]="'bot'" [origin]="vm.origin"></avatar>
										<avatar *ngIf="vm.isChatBotEnabled" size="sm" [user]="vm.consultant" [default]="'doctor'" style="position: absolute; bottom: 0; right: 0; border: 2px solid white; border-radius: 50%; background: white; margin-right: 20px;"></avatar>
										<avatar *ngIf="!vm.isChatBotEnabled" size="lg" [user]="vm.consultant" [default]="'doctor'"></avatar>
									</div>
								</div>
								<p *ngIf="!vm.isOutOfHoursMode" class="c-text c-text--center c-text--lg u-ost-lg">
									<span>{{ ('Word_Cloud_Intermediate.Dialog_Description' | translate).replace("%s", vm.user?.firstname) }}</span>
									<button *ngIf="vm.isChatBotEnabled"
										id="chatBotInfo"
										class="c-button c-button--tp c-button--icon--s1 u-no-pv"
										(click)="vm.openChatBotInfo()"
										title="{{ 'PreVisit.User_Tickets.View_Details' | translate }}">
										<i class="o-icon o-icon--info u-no-mr c-text c-text--sm" style="line-height: 1" aria-hidden="true"></i>
									</button>
								</p>
								<p *ngIf="vm.isOutOfHoursMode" class="c-text c-text--center c-text--lg u-ost-lg">
									{{ ('Word_Cloud_Intermediate.Dialog_Description_Out_Of_Hours' | translate).replace("%s1", vm.user?.firstname).replace("%s2", vm.getConsultantName()) }}
								</p>
								<div class="c-text c-text--center u-ost-xl u-osb-xl">
									<div class="c-tags__wrapper">
									<div *ngFor="let answer of vm.answers ; let $index=index"
										 class="c-tag" style="display: table-cell; height: auto">
                                        <i id="itemDescription{{$index}}" *ngIf="!!vm.descriptionMappings['en'][answer.defaultText] && !vm.user?.previsitUser" class="o-icon o-icon--info"
                                           style="margin: 4px 0 0 4px" aria-hidden="true"
                                           (click)="vm.openItemDescription($event, answer)"></i>
										<span *ngIf="vm.user?.previsitUser" id="answerLabelPrevisit{{$index}}">{{answer.text}}</span>
										<span *ngIf="!vm.user?.previsitUser"  id="answerLabel{{$index}}">{{answer.text}}</span>
										<i id="removeItem{{$index}}" *ngIf="vm.answers?.length > 1" class="o-icon o-icon--x"
													style="margin: 4px 0 0 4px" aria-hidden="true"
													(click)="vm.removeSelectedItem($event, answer)"></i>
									</div>
									</div>
								</div>
								<div *ngIf="!vm.isOutOfHoursMode" class="c-text c-text--center u-ost-lg">
									<button id="startChatButton" type="button" (click)="vm.startCommunicationChat()" class="c-button c-button--s1 c-button--lg">
										{{ 'Word_Cloud_Intermediate.Start_Chat_Button' | translate }}
									</button>
								</div>
								<div *ngIf="vm.isOutOfHoursMode" class="c-text c-text--center u-ost-lg">
									<button id="startBookingButton" type="button" (click)="vm.redirectToBooking()" class="c-button c-button--s1 c-button--lg">
										{{ 'Services.Button.Book' | translate }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
